import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { AggregateBusiness } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';

/**
 * 集計取引のアダプタ
 */
export class AggregateBusinessAdapter {
  /**
   * APIから来たAggregateBusiness型の情報をIBusinessに変換する
   * @param info - APIから来たAggregateBusiness型の情報
   * @returns - IBusinessの情報
   */
  public static adapt(info: AggregateBusiness | undefined): IBusiness | undefined {
    if (!info) return undefined;
    const parsedUserCustomParameters =
      info.userCustomParameters && typeof info.userCustomParameters === 'string' ? JSON.parse(info.userCustomParameters) : undefined;
    const factoryInfo: Partial<IBusiness> = {
      ...info,
      businessId: info.aggregateBusinessId,
      MOQ: Number(info.moq),
      stdInventoryIndices: {
        標準在庫指数: {
          max: Number(info.stdInventoryIndicesMax),
          min: Number(info.stdInventoryIndicesMin),
          option: {
            unit: info.stdInventoryIndicesUnit,
          },
        },
      },
      executionDate: info.executionDate ? DateService.convertMSUnixTimeToDate(info.executionDate) : undefined,
      aggregateBusinessResponsibleUsers: info.aggregateBusinessResponsibleUsers?.map((u) =>
        UserAccountFactory.create({ email: u.id, name: u.name })
      ),
      userUniqueNumber: parsedUserCustomParameters?.['顧客台帳ID'],
      lastCheckedAt: info.lastCheckedAt ? DateService.convertMSUnixTimeToDate(info.lastCheckedAt) : undefined,
      lastCheckedUser: info.lastCheckedUser
        ? UserAccountFactory.create({ email: info.lastCheckedUser.id, name: info.lastCheckedUser.name })
        : undefined,
      createAt: undefined,
      createdAt: info.createAt / 1000,
      updatedAt: info.updateAt / 1000,
    };
    return BusinessFactory.create(factoryInfo);
  }
}
